<template>
	<div class="heading">
		<h6 class="heading__title">
			{{ title }}
		</h6>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped src="./heading.scss" />
